import { readState } from "@/__main__/app-state.mjs";
import { appURLs } from "@/app/constants.mjs";
import { getAgentKey } from "@/game-val/utils.mjs";

const PLAYER_CARD_ROOT = "/blitz/val/PlayerCards/";

export const getProfileIcon = (playerCardId, lastAgentName) => {
  let iconUrl = "/blitz/val/assets/generic-profile-icon.png";
  if (playerCardId) {
    iconUrl = PLAYER_CARD_ROOT + playerCardId.toLowerCase() + ".webp";
  } else if (lastAgentName) {
    const {
      val: {
        cms: { agents },
      },
    } = readState;
    const agentKey = getAgentKey(lastAgentName);
    const agent = agents.find((a) => a.key === agentKey);
    return agent?.images.matchtile.url;
  }
  return `${appURLs.CDN}${iconUrl}`;
};
